import { Api } from 'api';
import { callApi } from 'root/appSaga';
import { takeEvery, put } from 'redux-saga/effects';
import * as invoiceActions from 'features/invoices/invoiceActions';

export function* companyInvoicesSaga() {
    return yield takeEvery(invoiceActions.REQUEST_COMPANY_INVOICES_START, getCompanyInvoices);
}

export function* getCompanyInvoices(params) {
    try {
        const companyId = params.payload.companyId;
        const invoices = yield callApi(Api.getCompanyInvoices, companyId);
        yield put(invoiceActions.getCompanyInvoicesCompleted(invoices));
    } catch (error) {
        yield put(invoiceActions.getCompanyInvoicesError(error));
    }
}
